export default "__VITE_ASSET__qV66Afnz__"